import { LocationCity } from '@mui/icons-material'
import LocationList from './LocationList'
import LocationEdit from './LocationEdit'
import LocationCreate from './LocationCreate'

const locationIndex = {
  icon: LocationCity,
  list: LocationList,
  edit: LocationEdit,
  create: LocationCreate,
}

export default locationIndex
